import script from "./textAreaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./textAreaComponent.vue?vue&type=script&setup=true&lang=js"

import "./textAreaComponent.vue?vue&type=style&index=0&id=3839ecaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3839ecaa"]])

export default __exports__